import { trigger, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { switchMap, tap } from 'rxjs/operators';
import { Order, PaymentMethod } from '../../models/order';
import { OrderService } from '../../services/order.service';
import { ConfirmDeliveryResult } from './confirm-delivery/confirm-delivery.component';
import { OrderDeliveredPhotoComponent } from './order-delivered-photo/order-delivered-photo.component';

export enum EndDeliveryOrderView { PaymentReminder, ConfirmDelivery }

@Component({
  templateUrl: './end-delivery.component.html',
  styleUrls: ['./end-delivery.component.scss'],
  animations: [
    trigger('enterTrigger', [

      transition('void => *', [style({ opacity: '0' }), animate('500ms')])
    ])
  ]
})
export class EndDeliveryComponent implements OnInit {
  readonly EndDeliveryOrderView: typeof EndDeliveryOrderView = EndDeliveryOrderView;
  endDeliveryOrderView?: EndDeliveryOrderView;

  @Input({ required: true }) order!: Order;
  constructor(
    private modalController: ModalController,
    private orderService: OrderService,
  ) { }

  ngOnInit() {
    const paymentComplete = this.order.order.paymentComplete || this.order.order.paymentType == PaymentMethod.Transfer;
    this.endDeliveryOrderView = paymentComplete ? EndDeliveryOrderView.ConfirmDelivery : EndDeliveryOrderView.PaymentReminder;
  }

  async onConfirmDeliveryResult(confirmDeliveryResult: ConfirmDeliveryResult): Promise<void> {
    switch (confirmDeliveryResult) {
      case ConfirmDeliveryResult.DeliverdToClient:
        this.endDelivery();
        break;
      case ConfirmDeliveryResult.DeliveredAtDoor:
        await this.openCameraModal();
        this.endDelivery();
        break;
      case ConfirmDeliveryResult.Cancel:
        const topModal = await this.modalController.getTop();
        if (topModal) {
          await this.modalController.dismiss();
        }
        break;
    }
  }

  async onPaymentReminderResult(paymentConfirmed: boolean): Promise<void> {
    const skipConfirmDeliveryForPaymentTypes = [PaymentMethod.Cash, PaymentMethod.QrCode, PaymentMethod.Transfer, PaymentMethod.QR, PaymentMethod.Card];
    if (paymentConfirmed) {
      if (skipConfirmDeliveryForPaymentTypes.includes(this.order.order.paymentType)) {
        this.endDelivery();
        return;
      }

      this.endDeliveryOrderView = EndDeliveryOrderView.ConfirmDelivery;
    } else {
      const topModal = await this.modalController.getTop();
      if (topModal) {
        await this.modalController.dismiss();
      }
    }
  }

  async openCameraModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: OrderDeliveredPhotoComponent,
      cssClass: 'picture-delivered-modal-css',
      id: 'open-camera',
      componentProps: {
        orderId: this.order.id
      }
    });
    return await modal.present();
  }

  private endDelivery(): void {
    this.orderService.endDelivery(this.order.id)
      .pipe(
        switchMap(() => this.orderService.refreshOrders()),
        tap(() => {
          this.modalController.dismiss(undefined, undefined, 'end-delivery');
          this.modalController.dismiss(undefined, undefined, 'order-preview');
        })
      ).subscribe();
  }
}
